module.exports = __webpack_public_path__ + "static/media/instructivosc6.3e4c00a9.png";